import { render } from "./Recipe_Details.vue?vue&type=template&id=2dc46848"
import script from "./Recipe_Details.vue?vue&type=script&lang=js"
export * from "./Recipe_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__